module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjE4MSIgdmlld0JveD0iMCAwIDMwMSAxODEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjQ0UxMTI2IiBkPSJNLjUuNWgzMDB2MTgwSC41eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0uNS41bDIwOC4yNDggMTgwSDMwMC41TDkyLjI1My41eiIvPjxwYXRoIGZpbGw9IiMwMDAiIGQ9Ik0xNS43OTIuNWwyMDguMjQ3IDE4MGg2MS4xNjlMNzYuOTYxLjV6Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-tt.svg
// module id = 1ThJ
// module chunks = 2